// https://vee-validate.logaretm.com/v2/guide/getting-started.html#installation
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import ja from 'vee-validate/dist/locale/ja';

Vue.use(VeeValidate, { locale: 'ja' });
Validator.localize('ja', ja);

// メッセージ修正
const dictionary = {
  ja: {
    messages: {
      required: () => '必須項目です',
      confirmed: () => 'パスワードが一致しません',
      url: () => 'httpから始まる有効なURLを入力してください',
      numeric: () => '整数のみ入力可能です',
      email: () => '有効なメールアドレスではありません',
      alpha_num: () => '英数字のみ使用できます',
      min: (param, length) => length + '文字以上入力してください',
      max: (param, length) => length + '文字以内で入力してください',
    },
  }
}
Validator.localize(dictionary);
Validator.extend('number', {
  getMessage: field => '数値の先頭に0は入力できません',
  validate: value => !(value.toString().match(/^(0).*$/))
});
Validator.extend('zero', {
  getMessage: field => '0のみの入力できません',
  validate: value => !(value.toString().match(/^(0*)$/))
});
Validator.extend('prompt', {
  getMessage: field => '入力ください',
  validate: (value, args) => {return !(!value)}
});